import { combineReducers } from 'redux';

const rootReducer = () =>
	combineReducers({
		routing: () => ({}),
	});

export default rootReducer;
